import api from '@/api'
import endpoints from '@/api/endpoints'
import Vue from 'vue'

const state = {
    planWorkingStatus: false,
    productListOfCurrentPlan: []
}

const getters = {}

const mutations = {
    SET_PRODUCT_LIST(state, products) {
        state.planWorkingStatus = true
        state.productListOfCurrentPlan = products
    },
    ADD_TO_SHIPPING_PLAN(state, product) {
        let productExistIndex = -1
        let productExist = state.productListOfCurrentPlan.find((selectedProduct, index) => {
            productExistIndex = index
            return selectedProduct.product.id === product.id
        })

        if (!!productExist) {
            Vue.set(state.productListOfCurrentPlan, productExistIndex, {
                ...state.productListOfCurrentPlan[productExistIndex],
                quantitySent: ++state.productListOfCurrentPlan[productExistIndex].quantitySent
            })
        } else {
            state.productListOfCurrentPlan.push({
                product,
                quantitySent: 0,
                id: null
            })
        }
    },
    RESET_PRODUCT_LIST(state) {
        state.planWorkingStatus = false
        state.productListOfCurrentPlan = []
    }
}

const actions = {
    getShipments({dispatch}, params) {
        return api('GET', endpoints.incomesShipment, null, params).then(response => response)
    },
    getPlans({dispatch}) {
        return api('GET', endpoints.incomesPlans).then(response => response)
    },
    getSpecificPlan({dispatch}, id) {
        return api('GET', endpoints.income(id)).then(response => response)
    },
    createPlan({dispatch}) {
        return api('POST', endpoints.incomesShipment).then(response => response)
    },
    cancelReplenishment({dispatch}, id) {
        return api('PATCH', endpoints.incomeCancel(id)).then(response => {
            dispatch('globalAlertAction', {
                type: 'info',
                title: `Replenishment ID:${id}`,
                message: 'canceled',
                timeout: 7000
            })
            return response
        })
    },
    deleteReplenishment({dispatch}, id) {
        return api('DELETE', endpoints.income(id)).then(response => {
            dispatch('globalAlertAction', {
                type: 'info',
                title: `Replenishment ID:${id}`,
                message: 'deleted',
                timeout: 7000
            })
            return response
        })
    },
    addToShippingPlan({dispatch}, payload) {
        let body = {
            productId: payload.productId,
            quantity: payload.quantity ? payload.quantity : 1,
        }
        return api('POST', endpoints.incomesItems(payload.planId), body).then(response => {
            dispatch('globalAlertAction', {
                type: 'success',
                title: 'Done.',
                message: 'Succeed added'
            })
            return response
        })
    },
    deleteFromShippingPlan({dispatch}, payload) {
        return api('DELETE', endpoints.incomesItemProduct(payload.planId, payload.productId)).then(response => {
            dispatch('globalAlertAction', {
                type: 'info',
                title: `Product ID:${payload.productId}`,
                message: `removed form Plans ID:${payload.planId}`,
                timeout: 7000
            })
            return response
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/replenishment.js